export const initiateCall = (phoneNumber: string): void => {
  if (!phoneNumber) {
    console.error('Phone number is missing.');
    return;
  }

  const cleanNumber = phoneNumber.replace(/[^0-9+]/g, '');

  window.location.href = `tel:${cleanNumber}`;
};
